import * as React from 'react';
/**
 * {@docCategory ScrollablePane}
 */
export var ScrollbarVisibility = {
    auto: 'auto',
    always: 'always',
};
export var ScrollablePaneContext = React.createContext({
    scrollablePane: undefined,
    window: undefined,
});
//# sourceMappingURL=ScrollablePane.types.js.map